import React from "react";
import Grid from "@material-ui/core/Grid";
import classes from "./Intro.module.css";
import Ratio from "react-ratio";
const Photo = (props) => {

  return (
    <Grid item xs={6} sm={3}>
        <Ratio ratio= {5/7}>
        <div
        className={classes.landingPicture}
        style={{
          background: `url(${props.imgURL})`,
          height: "100%",
          backgroundPosition: "center",
          backgroundSize: "cover",
          width:"100%"
        }}
      >
        <p>{props.text}</p>
      </div>
        </Ratio>
    </Grid>
  );
};

export default Photo;
